import { FC, useCallback } from "react";
import styles from "./location.module.scss";
import { formatAddress, formatPhone } from "../../../utils/stringFormatter";
import { getGoogleMapsDirectionUrl } from "../../../utils/map";
import { IVDPBlockData, IVDPPageBlock, VDPBlockPosition } from "../../../types/vdp";
import { getTranslationModule } from "../../../utils/translations";
import VDPSection from "@/ui/page-components/vehicle-details-page/vdp-section";
import VDPButton, { VDPButtonType } from "@/ui/page-components/vehicle-details-page/button";
import { LeadSection } from "@/types/lead";
import { findDepartment } from "@/utils/findDepartment";
import useAnalytics from "@/analytics/useAnalytics";

const DealerLocation: FC<IVDPPageBlock> = ({ vdpGlobalData, siteData, pageContext, translations }) => {
  const { sendAnalyticsEvent } = useAnalytics();
  const t_vdp = getTranslationModule(translations, "vdp");
  const t_common = getTranslationModule(translations, "common");
  const vehicle = vdpGlobalData.vehicle;

  const dealer = siteData.dealerInfos.find((item) => item.id === vehicle.dealer) || siteData.dealerInfos[0];
  const addressString = formatAddress(dealer?.address);
  const primaryPhone = dealer?.departments.find((d) => d.primary === true)?.phone;
  const phone = findDepartment(dealer?.departments || [], LeadSection.SALES).phone || primaryPhone || "";
  const getDirectionsLink = dealer?.location ? getGoogleMapsDirectionUrl(dealer?.location) : "";

  const onPhoneClick = useCallback(() => {
    sendAnalyticsEvent("asc_click_to_call", {
      comm_phone_number: phone,
      department: "sales",
    });
    window.location.href = `tel:+${phone}`;
  }, [phone, sendAnalyticsEvent]);

  const onAdressClick = useCallback(() => {
    window.location.href = getDirectionsLink;
  }, [getDirectionsLink]);

  return (
    <VDPSection title={t_vdp("vehicle_location")} subtitle={`${vehicle.make} ${vehicle.model} ${vehicle.trim}`}>
      <div className={styles.info}>
        <div className={styles.dealer}>
          <span className={styles.dealerName}>{dealer?.name}</span>
          <span className={styles.dealerAddress}>{addressString}</span>
        </div>
        <div className={styles.actions}>
          <VDPButton
            name={"vdpLocationDirection"}
            className={styles.button}
            onClick={onAdressClick}
            title={t_common("get_direction")}
            isMobile={pageContext.isSmartphone}
          />
          <VDPButton
            type={VDPButtonType.PRIMARY}
            name={"vdpLocationCall"}
            className={styles.button}
            onClick={onPhoneClick}
            title={`${t_common("call")} ${formatPhone(phone)}`}
            isMobile={pageContext.isSmartphone}
          />
        </div>
      </div>
    </VDPSection>
  );
};

const VDPBlockData: IVDPBlockData = {
  component: (props: IVDPPageBlock, key: any) => (
    <DealerLocation
      key={key}
      config={props.config}
      siteData={props.siteData}
      pageContext={props.pageContext}
      renderingPosition={props.renderingPosition}
      vdpGlobalData={props.vdpGlobalData}
      translations={props.translations}
    />
  ),
  position: VDPBlockPosition.LEFT,
};

export default VDPBlockData;
